import AutoReplenishShippingGroups from 'components/FrictionlessCheckout/ShippingMethods/AutoReplenishShippingGroups/AutoReplenishShippingGroups';

export default AutoReplenishShippingGroups;
